module.exports = __webpack_public_path__ + "img/FAVBET.d449ef19.svg";